  import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import PersonIcon from "@material-ui/icons/Person";
import AddIcon from "@material-ui/icons/Add";
import Typography from "@material-ui/core/Typography";
import { blue } from "@material-ui/core/colors";

import GlobalApi from "./../../Global";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
});

function SimpleDialog(props) {
  const classes = useStyles();
  const { onClose, selectedValue, open } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">Set Action</DialogTitle>
      <List>
        {props.data.map((value) => (
          <ListItem
            button
            onClick={() => handleListItemClick(value)}
            key={value.id}
          >
            <ListItemAvatar>
              <Avatar className={classes.avatar}>
                <PersonIcon />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={value.title} />
          </ListItem>
        ))}

        {/* <ListItem autoFocus button onClick={() => handleListItemClick('addAccount')}>
          <ListItemAvatar>
            <Avatar>
              <AddIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText primary="Add account" />
        </ListItem> */}
      </List>
    </Dialog>
  );
}

SimpleDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};

export default function Action(props) {
  const [open, setOpen] = React.useState(props.open);
  const [selectedValue, setSelectedValue] = React.useState(
    props?.HierarchyAction
  );

  // console.log(selectedValue, props);
  const [data, setData] = React.useState([]);
  const handleClickOpen = () => {
    setOpen(true);
  };

  React.useEffect(() => {
    getHierarchyActions();
  }, []);

  const getHierarchyActions = () => {
    let localstorage = localStorage.getItem("UserData");

    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      organization_id: data.organization_id,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/HierarchyAction/get_all_hierarchy_actions?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          // console.log(response);
          setData(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            // console.log("opopopop");
            getHierarchyActions();
          }
        }
      })
      .catch((error) => console.log(error.message));
  };

  const handleClose = async (value) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    if (value) {
      let req = await fetch(
        GlobalApi + "/HierarchyOrganization/edit_hierarchy_organization",
        {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            hierarchy_action_id: value.id,
            hierarchy_organization_id: props.id,
          }),
        }
      );

      let reqJson = await req.json();

      setOpen(false);
      setSelectedValue(value);
    }
  };

  return (
    <>
      <Typography>
        Selected Action: <br />{" "}
        <div style={{ fontWeight: "bold", color: "white" }}>
          {" "}
          {selectedValue?.title ? selectedValue.title : "None" }{" "}
        </div>
      </Typography>
      <br />
      <Button
        variant="outlined"
        size="small"
        color="default"
        onClick={handleClickOpen}
      >
        Action
      </Button>
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        onClose={handleClose}
        data={data}
      />
    </>
  );
}
